import React from 'react'
import { Divider } from "@mui/material"
import { AppLabelValueBlock } from "@components"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"

export default function PopoverCarFeatures({ priceData }) {
	const { id_category, id_fuel_policy_translation, is_prepaid_translation, pickup_date } = priceData
	return <>
		<Divider sx={{ my: .5 }}/>
		<AppLabelValueBlock label="Category" value={id_category}/>
		<AppLabelValueBlock label="Fuel" value={id_fuel_policy_translation}/>
		<AppLabelValueBlock label="Payment" value={is_prepaid_translation}/>
		<AppLabelValueBlock label="PickUp" value={formatDate(pickup_date, {
			receivedFormat: dateFormatReceiver(pickup_date),
			isString: true
		})}/>
	</>
}